import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, Button, Grid, FormHelperText } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import SelectDropdown from '../components/common/FormSelectDropdown';
// import { getCountries, getHCGlobalFilters } from '../Services/api/projectService';
import { useProjectApiClient } from "../Services/api/projectService"
import { useApiClient } from "../Services/api/copyProjectService"

import {  successToast,errorToast } from "../utils/toast";

interface CopyProjectModalProps {
  open: boolean;
  onClose: () => void;
  onRefresh: () => void;
  projectName: string;
  projectId: string;
  projectKey: string;
  existingCountry?: string;
  imageName?: string;
  category_Key:string;
  subcategory_key:string;
  brand_key:string;
}

const CopyProjectModal: React.FC<CopyProjectModalProps> = ({ open, onClose,onRefresh, projectName, projectId, projectKey, existingCountry, imageName, category_Key, subcategory_key, brand_key }) => {
  const { createCopyProject } =  useApiClient();

  const {  getHCGlobalFilters } =  useProjectApiClient();

  const { control, handleSubmit , formState: { errors }, clearErrors, reset } = useForm({
    defaultValues: {
      newProjectName: `${projectName}_copy`,
      selectedCountry: existingCountry || '',
      imageName: imageName || '',
      category_Key: category_Key || '',
      subcategory_key: subcategory_key || '',
      brand_key: brand_key || '',
    },
  });

  const [countryList, setCountryList] = useState<{ key: number; value: string }[]>([]);

  // Reset form when the modal opens or project name changes
  useEffect(() => {
    if (open) {
      reset({
        newProjectName: `${projectName}_copy`,
        selectedCountry: existingCountry || '',
        imageName: imageName || '',
        // category_Key: category_Key || '',
        // subcategory_key: subcategory_key || '',
        // brand_key: brand_key || '',
      });
    }
  }, [open, projectName, existingCountry,imageName, reset]);

  // Fetch country data and set preselected country if applicable  

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const payload = {
          buid: [],
          countryKey: [],
          categoryKey: [Number(category_Key)], // Use props dynamically
          subCategoryKey: [Number(subcategory_key)],
          brandKey: [Number(brand_key)],
        };
  
       // console.log("countryPayload", payload);
        const response = await getHCGlobalFilters(payload);
  
        if (response && response.data.country) {
          // Format country list
          let formattedCountries = response.data.country.map((item: any) => ({
            key: item.key, // Ensure this is the correct key for SelectDropdown
            value: item.value,
          }));
  
          // Filter out the existing country
          formattedCountries = formattedCountries.filter(
            (country) => country.value !== existingCountry
          );
  
         // console.log("Filtered Countries:", formattedCountries);
          setCountryList(formattedCountries);
  
          // Reset without selected country
          reset({
            newProjectName: `${projectName}_copy`,
            selectedCountry: '',
          });
        } else {
          console.error("No country data found:", response);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
  
    if (open) {
      fetchCountries();
    }
  }, [category_Key, subcategory_key, brand_key, open]); // Removed existingCountry from dependencies
  
  

  const onSubmit = async (data: any) => {
    // console.log('Submitting with:', {
    //   projectName,
    //   projectId,
    //   projectKey,
    //   newProjectName: data.newProjectName,
    //   selectedCountry: data.selectedCountry,
    //   imageName: data.imageName,
    // });
   
    const payload = {
      projectName: data.newProjectName,
      projectId,
      imageName: data.imageName, // Provide a value if needed
      countryKey: Number(data.selectedCountry),
      createdBy: 'admin_user', // Replace with actual user data
    }; 
  
    try {
      const response = await createCopyProject(payload);
      if (response) {
        const duplicateMsg =
          Array.isArray(response?.result) &&
          response?.result[0]?.[0]?.[""] === "Project with the same name already exists";
        if (duplicateMsg) {
          errorToast("Project with the same name already exists!");
        } else {
          successToast("Project copied successfully!");
          onClose();
          onRefresh();
        }
      } else {
        errorToast("Please select required fields.");
      }
    } catch (error) {
      console.error("Error submitting copy project:", error);
      errorToast("An error occurred while copying the project.");
    }
  };

  const handleCancel = () => {
    reset({
      newProjectName: `${projectName}_copy`,
      selectedCountry: existingCountry || '',
    });
    onClose();
  };


  return (

    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>

      <DialogTitle style={{ color: '#0052CC', fontWeight: 'bold', borderBottom:'1px solid #ccc' }}>
        Copy Project <br />       
      </DialogTitle>
      <div className='projectnamedisplay'>Selected Project: <b>{`${projectName}`}</b></div>

      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={3}>
            {/* Hidden Fields */}
            <input type="hidden" value={projectId} />
            <input type="hidden" value={projectKey} />
            <Controller
              name="imageName"
              control={control}
              render={({ field }) => (
                <input type="hidden" {...field} />
              )}
            />
             <Controller
                name="category_Key"
                control={control}
                render={({ field }) => (
                  <input type="hidden" {...field} />
                )}
              />
              <Controller
                name="subcategory_key"
                control={control}
                render={({ field }) => (
                  <input type="hidden" {...field} />
                )}
              />
              <Controller
                name="brand_key"
                control={control}
                render={({ field }) => (
                  <input type="hidden" {...field} />
                )}
              />

            {/* Project Name */}
            <Grid item xs={12}>
              <label className='projectnamedisplaylabel'>Copy your Project <label className='feelfreetext'>(Feel free to Rename)</label> <span style={{ color: 'red' }}>*</span></label>
              <Controller
              
                name="newProjectName"
                control={control}
                rules={{ required: 'Project name is required' }}
                render={({ field }) => (
                  <TextField
                  className='textfieldblue'
                    {...field}
                    fullWidth
                    error={!!errors.newProjectName}
                    helperText={errors.newProjectName?.message}
                  />
                )}
              />
            </Grid>

            {/* Country Dropdown */}
            {/* <Grid item xs={12}>
              <label className='projectnamedisplaylabel'>Select a Country to clone this project <span style={{ color: 'red' }}>*</span></label>
            </Grid>
            <Grid item xs={12}>
             
              <Controller
                name="selectedCountry"
                control={control}
                rules={{ required: 'Country is required' }}
                render={({ field }) => (
                  <div className='selectacountry'>
                  <SelectDropdown
                    filterKey=""
                    label=""
                    value={field.value}
                    onChange={(val) => {
                      field.onChange(val);
                      clearErrors("selectedCountry");
                    }}
                    options={countryList}
                    isError={!!errors.selectedCountry}
                  />
                  </div>
                )}
              />
              {errors.selectedCountry && <FormHelperText style={{ color: 'red' }}>{errors.selectedCountry.message}</FormHelperText>}
            </Grid>   */}
            {/* Buttons */}
            <Grid item xs={6}>
            <Button onClick={handleCancel} variant="outlined" color="secondary" fullWidth style={{ backgroundColor: '#ccc', color: '#000', borderRadius:'20px', border:'1px solid #999',fontSize:"13px"  }} >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button type="submit" variant="contained" style={{ backgroundColor: '#2A3FBF', color: '#fff', borderRadius:'20px', fontSize:"13px" }} fullWidth>
                Proceed
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CopyProjectModal;
